import React, { useState } from 'react';
import { Paper } from '@mui/material';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { FormSelect } from 'components/form/FormSelect';
import ApplicationReports from 'pages/Reports';
import { ReportTypes } from '../../../types';
import { REPORT_OPTIONS } from '../../../constants';
import { LenderPerformance } from '../../components';

export const DealerReportsPage = () => {
  const [selectedReport, setSelectedReport] = useState<ReportTypes>(ReportTypes.ApplicationReports);

  return (
    <PageContainer>
      <Paper sx={{ p: 2, mb: 2 }}>
        <FormSelect
          sx={{ width: '300px' }}
          value={selectedReport}
          options={REPORT_OPTIONS}
          onValueChange={value => setSelectedReport(value as ReportTypes)}
        />
      </Paper>

      {selectedReport === ReportTypes.ApplicationReports ? <ApplicationReports /> : <LenderPerformance />}
    </PageContainer>
  );
};
